import { useField } from 'formik';
import React from 'react';
import { FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';
export const FormikRadioGroup = props => {
    const { label, name, isBoolean, options, grid, onChange } = props;
    const [field, meta, { setValue }] = useField(name);
    return (React.createElement(Grid, Object.assign({ item: true }, grid),
        label && React.createElement(Typography, { variant: 'body2' }, label),
        React.createElement(FormControl, { name: name, error: meta.touched && Boolean(meta.error), component: 'fieldset' },
            React.createElement(RadioGroup, Object.assign({ row: true, "aria-label": label }, field, { name: name, onChange: event => {
                    if (isBoolean) {
                        setValue(event.target.value === 'true');
                        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value === 'true');
                    }
                    else {
                        setValue(event.target.value);
                        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
                    }
                } }), options.map(option => typeof option === 'string' ? (React.createElement(FormControlLabel, { key: option, value: option, control: React.createElement(Radio, { color: 'primary' }), label: option })) : (React.createElement(FormControlLabel, { key: option.value.toString(), value: option.value, control: React.createElement(Radio, { color: 'primary' }), label: option.label }))))),
        meta.error && React.createElement(FormHelperText, null, meta.error)));
};
export default FormikRadioGroup;
//# sourceMappingURL=FormikRadioGroup.js.map